// 导入所有接口
import https from './axios'
import apis from './apiList'

// vue 全局注册自定义方法和指令
//vue3注册方法
const install = Vue => {
  if (install.installed) return
  install.installed = true
  Object.defineProperties(Vue.prototype, {
    // 注意，此处挂载在 Vue 原型的 $api 对象上
    $apis: {
      get() {
        return apis  //所有API的URL
      }
    },
    $http: {
      get() {
        return https
      }
    }
  })
}
export default install

//vue2注册指令
//  install(Vue){
//     Vue.directive('pre',{
//         inserted(button,bind){
//             button.addEventListener('click',()=>{
//                 if(!button.disabled){
//                     button.disabled = true;
//                     setTimeout(()=>{
//                         button.disabled = false
//                     },1000)
//                 }
//             })
//         }
//     })
// }
// export default install

/****vue3 注册install函数组件，该组件会挂载在全局所有页面***/
// 1. btn.vue写好逻辑与DOM节点，显示隐藏由install函数里控制组件的style
// <template>
//     <el-button>按钮2</el-button>
// </template>

//vue3 注册install函数组件，该组件会挂载在全局所有页面
// 2. "./components/btn/index.js"文件代码：
// import {
//     render,
//     markRaw,
//     h
// } from 'vue'  //用这种方式才能使用公共方法和样式，普通的是app独立开无法使用全局函数与样式
// import myCom from './btn.vue'

// const install = (App)=>{
//     let vNode = h({
//         data() {
//             return {
//                 isShow: false,
//             }
//         },
//         render() {
//             return h(myCom,{
//                 "style":{display:this.isShow?'block':'none'}
//                 // class:'aa'
//             })
//         }
//     })

//     const vNodeDom = document.createElement('div')
//     document.body.appendChild(vNodeDom)
//     vNode.appContext = App._context
//     render(vNode, vNodeDom)

//     App.config.globalProperties.$show = function() {
//         vNode.component.proxy.isShow = true
//     }

//     App.config.globalProperties.$hide = function() {
//         vNode.component.proxy.isShow = false
//     }
// }
//在main.js引入install函数，全局使用
// import myBtn from './components/btn/index'
// app.use(myBtn)
// .use(router)
// .use(store)
// .mount('#app')



//在模块中使用：
// this.$show()
// // setTimeout(()=>{
// //     this.$hide()
// // },3000)
// 或者如用setup:
// import {getCurrentInstance} from "vue";
// export default {
//     setup(){
//         const {proxy} = getCurrentInstance()
//         proxy.$show()
//     }
// }
// export default install


// WEBPACK FOOTER //
// ./src/http/index.js